import {replayIntegration, init as sentryInit} from '@sentry/react';
import {getAppConfig} from 'src/app/get-app-config';

const init = () => {
    getAppConfig().then(({SENTRY_DSN, SENTRY_ENVIRONMENT}) => {
        if (SENTRY_DSN) {
            sentryInit({
                dsn: SENTRY_DSN,
                environment: SENTRY_ENVIRONMENT,
                integrations: [replayIntegration()],
                // @ts-expect-error
                release: APP_VERSION,
                tracesSampleRate: 1,
            });
        }
    });
};

init();
